import { Stack as MuiStack, Typography } from "@mui/material";
import { StepType } from "@reactour/tour"
import { FC, PropsWithChildren } from "react";


const Stack: FC<PropsWithChildren> = ({ children }) => {
    return (
        <MuiStack sx={{ padding: '10px 10px 0px 10px' }}>
            {children}
        </MuiStack>
    )
}

export const TourStepsNavigation: StepType[] = [
    {
        selector: '#Nav',
        content: () => (
            <Stack>
                <Typography>
                    Navigation through the Dealer Portal can be done here
                </Typography>
            </Stack>
        ),
        position: 'center'
    },
    {
        selector: '#ToggleNavExpand',
        content: () => (
            <Stack>
                <Typography>
                    Click here to expand or collapse the navigation
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [-15, 0, 0, 15] }
    },
    {
        selector: "#DashboardNavLink",
        content: () => (
            <Stack>
                <Typography>
                    The Dashboard provides an overview of most important areas of your account
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#OrdersNavLink",
        content: () => (
            <Stack>
                <Typography>
                    On the Orders page you can view all your previous orders, and start new ones
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#WarrantyRegistrationNavLink",
        content: () => (
            <Stack>
                <Typography>
                    Registration is where you will register your MadJax carts to allow for warranty support
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#WarrantyClaimsNavLink",
        content: () => (
            <Stack>
                <Typography>
                    On the Warranty Claims page is where you can view the status of your warranty claims, leave comments / feedback about a claim, and submit new claims
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#TechSupportNavLink",
        content: () => (
            <Stack>
                <Typography>
                    On the Technical Support page is where you can view the status of your tech support tickets, leave comments / feedback about a ticket, and submit new tickets
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#DDLNavLink",
        content: () => (
            <Stack>
                <Typography>
                    View your DLL financing account
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#ResourcesNavLink",
        content: () => (
            <Stack>
                <Typography>
                    On the Resources page find marketing materials, training, digital resources, and technical information
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#LogoutNavLink",
        content: () => (
            <Stack>
                <Typography>
                    Here you can logout of the Dealer Portal
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [0, 0, 0, 15] }
    },
    {
        selector: "#DealerProfileNavLink",
        content: () => (
            <Stack>
                <Typography>
                    Your dealer profile can be viewed and edited here. This includes current users on the account, updating company logo and more
                </Typography>
            </Stack>
        ),
        position: 'right',
        padding: { popover: [50, 0, 0, -50] }
    }
]

export const TourStepsOrderHistory: StepType[] = [
    {
        selector: '#OrderTypeSelect',
        content: () => (
            <Stack>
                <Typography>
                    Select the order type you would like to view by the tabs on top,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#SearchNewOrder',
        content: () => (
            <Stack>
                <Typography>
                    Search previous orders or begin a new order from scratch,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrdersTable',
        content: () => (
            <Stack>
                <Typography>
                    Your previous orders can be viewed on this table.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrderFunctions',
        content: () => (
            <Stack>
                <Typography>
                    You can do actions like view, or create from a current order.
                </Typography>
            </Stack>
        )
    },
]

export const TourStepsCartOrderPage: StepType[] = [
    {
        selector: '#CartOrderForm',
        content: () => (
            <Stack>
                <Typography>
                    To start your order fill out the form details here and add cart configurations.
                </Typography>
            </Stack>
        ),
    },
    {
        selector: '#CartConfigurations',
        content: () => (
            <Stack>
                <Typography>
                    This displays all carts on your order as well as the ability to edit, duplicate, or remove carts from an order.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#CartDrawerPullTab',
        content: () => (
            <Stack>
                <Typography>
                    Click here to view current order total, cart configurations break down, submit your order and more.
                </Typography>
            </Stack>
        )
    },
]

export const TourStepsCartOrderPageWInventory: StepType[] = [
    {
        selector: '#OrderTabs',
        content: () => (
            <Stack>
                <Typography>
                    Here you can switch between available inventory to add to your order and your current order.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#OrderTab', '#InventoryTab'],
        resizeObservables: ['#OrderTab', '#InventoryTab'],
    },
    {
        selector: '#CartOrderForm',
        content: () => (
            <Stack>
                <Typography>
                    To start your order fill out the form details here and add cart configurations.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#CartOrderForm'],
        resizeObservables: ['#CartOrderForm']
    },
    {
        selector: '#Inventory',
        content: () => (
            <Stack>
                <Typography>
                    On the inventory tab you can view current avaiable inventory to add to your order.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#OrderTab', '#InventoryTab'],
        resizeObservables: ['#OrderTab', '#InventoryTab'],
    },
    {
        selector: '#InventoryFilters',
        content: () => (
            <Stack>
                <Typography>
                    You can filter inventory here by cart series type, lifted or non-lifted, battery, color and more.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: [
            '#InventoryFiltersSelectedCarts',
            '#InventoryFiltersSeriesOptions',
            '#InventoryFiltersLiftKitOptions'],
        resizeObservables: [
            '#InventoryFiltersSelectedCarts',
            '#InventoryFiltersSeriesOptions',
            '#InventoryFiltersLiftKitOptions'
        ]
    },
    {
        selector: '#InventoryCarts',
        content: () => (
            <Stack>
                <Typography>
                    Here are some of the inventory carts available. To add a cart, click on the "-" or "+" buttons to adjust the quantity you want to add to your order.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#InventoryCart_0', '#InventoryCart_1', '#InventoryCart_2'],
        resizeObservables: ['#InventoryCart_0', '#InventoryCart_1', '#InventoryCart_2'],
    },
    {
        selector: '#InventoryFilters',
        content: () => (
            <Stack>
                <Typography>
                    You can filter inventory here by cart series type, lifted or non-lifted, battery, color and more.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: [
            '#InventoryFiltersSelectedCarts',
            '#InventoryFiltersSeriesOptions',
            '#InventoryFiltersLiftKitOptions'],
        resizeObservables: [
            '#InventoryFiltersSelectedCarts',
            '#InventoryFiltersSeriesOptions',
            '#InventoryFiltersLiftKitOptions'
        ]
    },
    {
        selector: '#CartConfigurations',
        content: () => (
            <Stack>
                <Typography>
                    This displays all carts added to your order as well as other actions like removing, customizing, and more.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#CartConfigurations'],
        resizeObservables: ['#CartConfigurations']
    },
    {
        selector: '#CartDrawerPullTab',
        content: () => (
            <Stack>
                <Typography>
                    Click here to view current order total, cart configurations break down, submit your order and more.
                </Typography>
            </Stack>
        ),
        highlightedSelectors: ['#CartDrawerPullTab'],
        resizeObservables: ['#CartDrawerPullTab']
    },
]

export const TourStepsOrdersDealerDisplay: StepType[] = [
    {
        selector: '#OrderTypeSelect',
        content: () => (
            <Stack>
                <Typography>
                    Select the order type you would like to view by the tabs on top,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#SearchNewOrder',
        content: () => (
            <Stack>
                <Typography>
                    Search previous orders and begin a new order from scratch,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrdersTable',
        content: () => (
            <Stack>
                <Typography>
                    Your previous show room display orders can be viewed on the table here,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrderFunctions',
        content: () => (
            <Stack>
                <Typography>
                    You can view the details of a previous display order here
                </Typography>
            </Stack>
        )
    },
]

export const TourStepsOrdersPrintMedia: StepType[] = [
    {
        selector: '#OrderTypeSelect',
        content: () => (
            <Stack>
                <Typography>
                    Select the order type you would like to view by the tabs on top,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#SearchNewOrder',
        content: () => (
            <Stack>
                <Typography>
                    Search previous orders and begin a new order from scratch,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrdersTable',
        content: () => (
            <Stack>
                <Typography>
                    Your previous print media orders can be viewed on the table here,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrderFunctions',
        content: () => (
            <Stack>
                <Typography>
                    You can view the details of a previous print media orders here
                </Typography>
            </Stack>
        )
    },
]

export const TourStepsOrdersMco: StepType[] = [
    {
        selector: '#OrderTypeSelect',
        content: () => (
            <Stack>
                <Typography>
                    Select the order type you would like to view by the tabs on top,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#SearchNewOrder',
        content: () => (
            <Stack>
                <Typography>
                    Search previous orders and begin a new order from scratch,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrdersTable',
        content: () => (
            <Stack>
                <Typography>
                    Your previous mco orders can be viewed on the table here,
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PreviousOrderFunctions',
        content: () => (
            <Stack>
                <Typography>
                    You can view the details of a previous mco orders here
                </Typography>
            </Stack>
        )
    },
]

export const WarrantyClaimHistory: StepType[] = [
    {
        selector: '#Search',
        content: () => (
            <Stack>
                <Typography>
                    Create a new warranty claim ticket or search existing tickets using the ticket number
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#WarrantyClaimsTable',
        content: () => (
            <Stack>
                <Typography>
                    Your active and closed warranty claims can be viewed in this table.
                </Typography>
            </Stack>
        )
    }
]

export const TechSupportHistory: StepType[] = [
    {
        selector: '#ViewTechDocs',
        content: () => (
            <Stack>
                <Typography>
                    Click here to view, download, or print technical support documents available for MadJax products.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#Search',
        content: () => (
            <Stack>
                <Typography>
                    Create a new technical support ticket or search existing tickets using the ticket number
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#TechSupportTable',
        content: () => (
            <Stack>
                <Typography>
                    Your active and closed technical support tickets can be viewed in this table.
                </Typography>
            </Stack>
        )
    }
]

export const TourStepsLeads: StepType[] = [
    {
        selector: '#LeadsList',
        content: () => (
            <Stack>
                <Typography>View your current leads. These are leads generated from approved addresses in your address book.  You can view your address book on the Dealer Profile page.</Typography>
            </Stack>
        )
    }
]

export const TourStepsLeadsDetail: StepType[] = [
    {
        selector: '#ProspectDetails',
        content: () => (
            <Stack>
                <Typography>You can view details about the prospect, as well as the status updates, and mark leads follow up and purchase status.</Typography>
            </Stack>
        )
    },
    {
        selector: '#ProspectContactInfo',
        content: () => (
            <Stack>
                <Typography>Prospect contact details and address.</Typography>
            </Stack>
        )
    },
    {
        selector: '#LeadDetails',
        content: () => (
            <Stack>
                <Typography>You can view details of the lead here.  What products the prospect is interested in, their online build submission and more.</Typography>
            </Stack>
        )
    },
]

export const DealerProfile: StepType[] = [
    {
        selector: '#MetaData',
        content: () => (
            <Stack>
                <Typography>
                    Edit your company profile, and view company dealer ID number
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#AddressBook',
        content: () => (
            <Stack>
                <Typography>
                    View, edit, delete, or modify saved address locations used for lead prospects, orders, and other forms used across the app.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#Licenses',
        content: () => (
            <Stack>
                <Typography>
                    View licenses such as LSV (low-speed-vehicle) status.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#PasswordReset',
        content: () => (
            <Stack>
                <Typography>
                    Reset your password used to login to the Dealer Portal.
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#UserList',
        content: () => (
            <Stack>
                <Typography>
                    View, edit, delete, or modifiy users for your account.
                </Typography>
            </Stack>
        )
    },
]

export const TourStepsDashboard: StepType[] = [
    {
        selector: '#NewsAndUpdates',
        content: () => (
            <Stack>
                <Typography>
                    View new and upcoming updates to MadJax products and services
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#RecentOrdersCard',
        content: () => (
            <Stack>
                <Typography>
                    View your most recent orders and reorder directly from the dashboard
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#DLLAvailabilityCard',
        content: () => (
            <Stack>
                <Typography>
                    View current loan status with DLL financing
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#WarrantyClaimsCard',
        content: () => (
            <Stack>
                <Typography>
                    View the status of your warranty claims, or open a specific claim directly to view more details
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#TechSupportCard',
        content: () => (
            <Stack>
                <Typography>
                    View the status of your technical support tickets, or open a specific ticket directly to view more details
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#Resources',
        content: () => (
            <Stack>
                <Typography>
                    View the status of your technical support tickets, or open a specific ticket directly to view more details
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#MadJaxLeads',
        content: () => (
            <Stack>
                <Typography>
                    View the status of your technical support tickets, or open a specific ticket directly to view more details
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#Invoices',
        content: () => (
            <Stack>
                <Typography>
                    View the status of your technical support tickets, or open a specific ticket directly to view more details
                </Typography>
            </Stack>
        )
    },
    {
        selector: '#TopBar',
        content: () => (
            <Stack>
                <Typography>
                    Call our customer service team, Submit a general comment / help request, and view individual page tutorials
                </Typography>
            </Stack>
        )
    }
]
